import userStore from "@/store/modules/userStore";
import {
  BmTaskFilter,
  bmTaskService,
} from "@/app/services/generated/bmtaskService";
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import { LocalDateTime } from "@js-joda/core";
import {
  isTaskInToDoSection,
  isTaskOverdue,
} from "@/components/pages/tasks/composables/tasks";
import { EnumTaskStatus } from "@/app/services/generated/enums/enumTaskStatus.generated";
import { reactive, readonly } from "vue";

let timerId = 0;

interface TaskStoreState {
  assignedTasksCount: number;
  assignedOverdueTasksCount: number;
}

const state = reactive<TaskStoreState>({
  assignedTasksCount: 0,
  assignedOverdueTasksCount: 0,
});

/**
 * Refreshes the task store, which updates the assigned / overdue counts for the menu.
 * Typically this call does not need to be awaited. Just kick it off and the menu chips
 * will update once the results are obtained.
 */
async function refresh() {
  if (
    !userStore.isAuthenticatedWithSelectedTenant.value ||
    !userStore.state.user
  ) {
    return;
  }

  const bmTaskFilter = new BmTaskFilter();
  bmTaskFilter.limitAssignedUserIds = [userStore.state.user.id];
  bmTaskFilter.limitStatuses = [EnumTaskStatus.open];

  try {
    const { bmTasks } = await bmTaskService.getBmTasksByFilter(bmTaskFilter);

    const dateTimeNow = LocalDateTime.now(tenantService.getTimezone());

    state.assignedTasksCount = bmTasks.filter((task) =>
      isTaskInToDoSection(task, dateTimeNow)
    ).length;

    state.assignedOverdueTasksCount = bmTasks.filter((task) =>
      isTaskOverdue(task, dateTimeNow)
    ).length;
  } catch {
    // Error getting counts. Leave them unchanged.
  }
}

async function startAutoRefresh() {
  if (timerId) {
    clearInterval(timerId);
    timerId = 0;
    state.assignedTasksCount = 0;
    state.assignedOverdueTasksCount = 0;
  }

  await refresh();

  timerId = +setInterval(refresh, 30000);
}

export default {
  state: readonly(state),
  startAutoRefresh,
  refresh,
};
